const invalidateToken = () => {
  localStorage.removeItem("jwt");
};

export default invalidateToken;
